import axios, { CreateAxiosDefaults } from 'axios';

import { requestError, requestSuccess, responseError, responseSuccess } from '../utils';

export const BASE_URL = process.env.NX_PUBLIC_BASE_API_URL;

const axiosOptions: CreateAxiosDefaults = {
  baseURL: BASE_URL,
  withCredentials: true,
};

const axiosClient = axios.create(axiosOptions);

axiosClient.interceptors.request.use((config) => {
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  }

  return requestSuccess({ domainUrl: BASE_URL })(config);
}, requestError);

axiosClient.interceptors.response.use(
  responseSuccess,
  responseError({
    options: axiosOptions,
    domainUrl: BASE_URL as string,
    axios: axiosClient,
  }),
);

export default axiosClient;
